import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { InfoSet } from "../InfoSets/InfoSet";
import { MacAddress } from "../Core/MacAddress";
import { IpAddress, IpVersion } from "../Core/IpAddress";
import { Device } from "../Core/Device";
import { SystemInfo } from "../InfoSets/SystemInfo";
import { AssetEntry, AssetTable } from "../InfoSets/AssetTable";
import { InfoSetTable } from "../InfoSets/InfoSetTable";
import { HashSet } from "../Utils/HashSet";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface ApEntryJson {
//    mac_address: string;
//    ethernet_mac_address: string;
//    ip_address: string;
//    net_mask: string;
//    gateway: string;
//    num_of_slots: string;
//    oper_status: string;
//    name: string;
//    location: string;
//    ap_type: string;
//    model: string;
//    boot_version: string;
//    sw_version: string;
//    ios_version: string;
//    serial_number: string;
//    vendor_name: string;
//}

export class ApEntry /*implements ISerializable*/ implements ObjectSerializer {
    public MacAddress: MacAddress;

    public EthernetMacAddress: MacAddress;
    public get HasEthernetMacAddress(): boolean {
        return this.EthernetMacAddress && !this.EthernetMacAddress.IsNull;
    }

    public IpAddress: IpAddress;
    public get HasIpAddress(): boolean {
        return this.IpAddress && this.IpAddress.IsValidDiscoveryAddress;
    }

    public NetMask: IpAddress;
    public get HasNetMask(): boolean {
        if (this.NetMask != null)
            return true;
        return false;
    }

    public Gateway: IpAddress;
    public get HasGateway(): boolean {
        return this.Gateway && this.Gateway.IsValidDiscoveryAddress;
    }

    public NumOfSlots: number;
    public get HasNumOfSlots(): boolean {
        return this.NumOfSlots > 0;
    }

    public OperStatus: string;
    public get HasOperStatus(): boolean {
        return !!this.OperStatus;
    }

    public Name: string;
    public get HasName(): boolean {
        return !!this.Name;
    }

    public Location: string;
    public get HasLocation(): boolean {
        return !!this.Location;
    }

    public ApType: string;
    public get HasApType(): boolean {
        return !!this.ApType;
    }

    public Model: string;
    public get HasModel(): boolean {
        return !!this.Model;
    }

    public BootVersion: string;
    public get HasBootVersion(): boolean {
        return !!this.BootVersion;
    }

    public SwVersion: string;
    public get HasSwVersion(): boolean {
        return !!this.SwVersion;
    }

    public IosVersion: string;
    public get HasIosVersion(): boolean {
        return !!this.IosVersion;
    }

    public SerialNumber: string;
    public get HasSerialNumber(): boolean {
        return !!this.SerialNumber;
    }

    public VendorName: string;
    public get HasVendorName(): boolean {
        return !!this.VendorName;
    }

    // Not-persisted
    public DeviceID: string;
    public get HasDeviceID(): boolean {
        return !!this.DeviceID;
    }

    constructor(apMacAddress?: MacAddress) {
        this.MacAddress = apMacAddress;
    }

    private Init() {
        this.EthernetMacAddress = null;

        this.IpAddress = null;
        this.NetMask = null;
        this.Gateway = null;

        this.NumOfSlots = 0;
        this.OperStatus = '';

        this.Name = '';
        this.Location = '';
        this.ApType = '';
        this.Model = '';
        this.BootVersion = '';
        this.SwVersion = '';
        this.IosVersion = '';
        this.SerialNumber = '';
        this.VendorName = '';

        this.DeviceID = '';
    }

    public CopyTo(apDevice: Device): void {
        if (apDevice == null)
            return;

        var sysInfo: SystemInfo = apDevice.AddSystemInfo();

        if (this.HasName) {
            if (!sysInfo.HasSystemName)
                sysInfo.SystemName = this.Name + '';
        }

        if (this.HasModel) {
            if (!sysInfo.HasSystemDescription)
                sysInfo.SystemDescription = this.Model + '';
        }

        if (this.HasLocation) {
            if (!sysInfo.HasSystemLocation)
                sysInfo.SystemLocation = this.Location + '';
        }

        var assetTable: AssetTable = apDevice.AddAssetTable();
        if (assetTable != null) {
            var chassisEntry: AssetEntry = assetTable.AddChassis();
            if (chassisEntry != null) {
                if (!chassisEntry.HasName && this.HasName)
                    chassisEntry.Name = this.Name + '';
                if (!chassisEntry.HasModelName && this.HasModel)
                    chassisEntry.ModelName = this.Model + '';
                if (!chassisEntry.HasSerialNum && this.HasSerialNumber)
                    chassisEntry.SerialNum = this.SerialNumber + '';

                if (!chassisEntry.HasSwRev && this.HasSwVersion)
                    chassisEntry.SwRev = this.SwVersion + '';
                if (!chassisEntry.HasFwRev && this.HasBootVersion)
                    chassisEntry.FwRev = this.BootVersion + '';
            }
        }
    }

    //public Deserialize(json: ApEntryJson): void {
    //    if (json.mac_address !== undefined)
    //        this.MacAddress = MacAddress.CreateFromString(json.mac_address);

    //    if (json.ethernet_mac_address !== undefined)
    //        this.EthernetMacAddress = MacAddress.CreateFromString(json.ethernet_mac_address);

    //    if (json.ip_address !== undefined)
    //        this.IpAddress = IpAddress.Create(json.ip_address);

    //    if (json.net_mask !== undefined)
    //        this.NetMask = IpAddress.Create(json.net_mask);

    //    if (json.gateway !== undefined)
    //        this.Gateway = IpAddress.Create(json.gateway);

    //    if (json.num_of_slots !== undefined)
    //        this.NumOfSlots = parseInt(json.num_of_slots);

    //    if (json.oper_status !== undefined)
    //        this.OperStatus = json.oper_status;

    //    if (json.name !== undefined)
    //        this.Name = json.name;

    //    if (json.location !== undefined)
    //        this.Location = json.location;

    //    if (json.ap_type !== undefined)
    //        this.ApType = json.ap_type;

    //    if (json.model !== undefined)
    //        this.Model = json.model;

    //    if (json.boot_version !== undefined)
    //        this.BootVersion = json.boot_version;

    //    if (json.sw_version !== undefined)
    //        this.SwVersion = json.sw_version;

    //    if (json.ios_version !== undefined)
    //        this.IosVersion = json.ios_version;

    //    if (json.serial_number !== undefined)
    //        this.SerialNumber = json.serial_number;

    //    if (json.vendor_name !== undefined)
    //        this.VendorName = json.vendor_name;
    //}

	public Write(obj: any, context: any): void {
		obj.ap_entry = {};
		obj = obj.ap_entry;

		obj.mac_address = ValueEncoder.EncodeMacAddress(this.MacAddress);

		if (this.HasEthernetMacAddress)
			obj.ethernet_mac_address = ValueEncoder.EncodeMacAddress(this.EthernetMacAddress);

		if (this.HasIpAddress)
			obj.ip_address = ValueEncoder.EncodeIpAddress(this.IpAddress);

		if (this.HasNetMask)
			obj.net_mask = ValueEncoder.EncodeIpAddress(this.NetMask);

		if (this.HasGateway)
			obj.gateway = ValueEncoder.EncodeIpAddress(this.Gateway);

		if (this.HasNumOfSlots)
			obj.num_of_slots = ValueEncoder.EncodeInteger(this.NumOfSlots);

		if (this.HasOperStatus)
			obj.oper_status = this.OperStatus;

		if (this.HasName)
			obj.name = this.Name;

		if (this.HasLocation)
			obj.location = this.Location;

		if (this.HasApType)
			obj.ap_type = this.ApType;

		if (this.HasModel)
			obj.model = this.Model;

		if (this.HasBootVersion)
			obj.boot_version = this.BootVersion;

		if (this.HasSwVersion)
			obj.sw_version = this.SwVersion;

		if (this.HasIosVersion)
			obj.ios_version = this.IosVersion;

		if (this.HasSerialNumber)
			obj.serial_number = this.SerialNumber;

		if (this.HasVendorName)
			obj.vendor_name = this.VendorName;
	}

	public Read(obj: any, context: any): void {
		if (!obj.ap_entry)
			throw new Error();
		obj = obj.ap_entry;

		if (obj.mac_address !== undefined)
			this.MacAddress = ValueEncoder.DecodeMacAddress(obj.mac_address);

        if (obj.ethernet_mac_address !== undefined)
			this.EthernetMacAddress = ValueEncoder.DecodeMacAddress(obj.ethernet_mac_address);

		if (obj.ip_address !== undefined)
			this.IpAddress = ValueEncoder.DecodeIpAddress(obj.ip_address);

        if (obj.net_mask !== undefined)
			this.NetMask = ValueEncoder.DecodeIpAddress(obj.net_mask);

        if (obj.gateway !== undefined)
			this.Gateway = ValueEncoder.DecodeIpAddress(obj.gateway);

		if (obj.num_of_slots !== undefined)
			this.NumOfSlots = ValueEncoder.DecodeInteger(obj.num_of_slots);

        if (obj.oper_status !== undefined)
            this.OperStatus = obj.oper_status;

        if (obj.name !== undefined)
            this.Name = obj.name;

        if (obj.location !== undefined)
            this.Location = obj.location;

        if (obj.ap_type !== undefined)
            this.ApType = obj.ap_type;

        if (obj.model !== undefined)
            this.Model = obj.model;

        if (obj.boot_version !== undefined)
            this.BootVersion = obj.boot_version;

        if (obj.sw_version !== undefined)
            this.SwVersion = obj.sw_version;

        if (obj.ios_version !== undefined)
            this.IosVersion = obj.ios_version;

        if (obj.serial_number !== undefined)
            this.SerialNumber = obj.serial_number;

        if (obj.vendor_name !== undefined)
		       this.VendorName = obj.vendor_name;
	}
}

export class ApTable extends InfoSetTable<MacAddress, ApEntry> {
    constructor(device: Device) {
        super(device);
    }

    public Add(apMacAddress: MacAddress): ApEntry {
        var apEntry: ApEntry = this._table.Item(apMacAddress);

        if (!apEntry) {
            apEntry = new ApEntry(apMacAddress);
            this._table.Add(apMacAddress, apEntry);
        }

        return apEntry;
    }

    public AddEntry(apEntry: ApEntry): boolean {
        if (this._table.ContainsKey(apEntry.MacAddress))
            return false;

        return this._table.Add(apEntry.MacAddress, apEntry);
    }
        
    public FindByName(apName: string): ApEntry {
        var foundApEntry: ApEntry = null;

        this._table.Some((pair) => {
            if (pair.Value.HasName && pair.Value.Name == apName) {
                foundApEntry = pair.Value;
                return true;
            }

        });

        return foundApEntry;
    }

    public FindByDeviceID(deviceID: string): ApEntry {
        var foundApEntry: ApEntry = null;

        this._table.Some((pair) => {
            if (pair.Value.HasDeviceID && pair.Value.DeviceID == deviceID) {
                foundApEntry = pair.Value;
                return true;
            }
        });

        return foundApEntry;
    }
        
    public get HasIpSightings(): boolean {
        return true;
    }

    public get IpSightings(): HashSet<IpAddress> {
        var ipAddresses = new HashSet<IpAddress>();

        this._table.ForEach((pair) => {
            if (pair.Value.HasIpAddress)
                ipAddresses.Add(pair.Value.IpAddress);

            if (pair.Value.HasGateway)
                ipAddresses.Add(pair.Value.Gateway);
        });

        return (ipAddresses);
    }

    public get HasMacSightings(): boolean {
        return true;
    }

    public get MacSightings(): HashSet<MacAddress> {
        var macAddresses = new HashSet<MacAddress>();

        this._table.ForEach((pair) => {
            if (pair.Value.HasEthernetMacAddress)
                macAddresses.Add(pair.Value.EthernetMacAddress);

            if (pair.Value.MacAddress != null)
                macAddresses.Add(pair.Value.MacAddress);
        });

        return (macAddresses);
    }

    //public DeserializeEntry(json: any): void {
    //    var entry = new ApEntry(null);
    //    entry.Deserialize(json);
    //    this.AddEntry(entry);
    //}

    //public EntryName(): string {
    //    return "ap_entry";
    //};

    //public static FromJson(json: any, device: Device): ApTable {
    //    var result = new ApTable(device);
    //    result.Deserialize(json);
    //    return result;
    //}

	public Write(obj: any, context: any): void {
		obj.ap_info = {};
		obj = obj.ap_info;

		obj.entries = [];
		ObjSerUtils.WriteObjSerCollection(obj.entries, this._table.Values(), context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.ap_info)
			throw new Error();
		obj = obj.ap_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new ApEntry();
				entry.Read(value, context);
				this.AddEntry(entry);
			}, this);
		}
	}
}
